<template>
    <div class="story-maker-sticker-menu-localisation">
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.localisation-title') }}</p>
        </div>
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input :placeholder="$t('dash.post-creator.overlay.search')" v-model="models.search">
        </div>

        <div class="list-item hide-scrollbar">
            <span class="loader" v-if="stateLoader"></span>
            <div class="item" v-else v-for="(place,index) in (models.search ? localisations : dataInstagramDefault.localisations)" @click="selectPlace(place)" :key="`localisation${index}`">
            
                <div class="info">
                    <p class="localisation">{{ place.name }}</p>
                    <p class="localisation-info">{{  place.location.street || place.location.city || place.location.country || place.location.zip  ? `${place.location.street || ''} ${place.location.city || ''} ${place.location.country || ''} ${place.location.zip || ''}` : place.name}}</p>
                </div>
        
            </div>
            
        </div>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import minxinPost from '@/components/mixins/Posts.vue'

    export default {
        mixins: [minxinPost],

        props: {
            dataInstagramDefault: Object,
        },

        data() {
            return {
                models: {
                    search : ''
                },
                stateLoader: false,
                timeoutInitSearch: null,
                localisations: []
            }
        },


        methods: {
            async searchPlace() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = false
                if(!this.models.search) return
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                    this.localisations = []
               
                    if (page) {
                        this.stateLoader = true
                        this.localisations = (await this.getLocation(page.id, this.models.search)).body.locations
                        this.stateLoader = false
                    }
                },1000)
                
            },

            async selectPlace(place) {
                this.$emit('addSticker','localisation', {
                    data: {
                        place,
                        styleVariant: 1
                    }
                })
            }
        },

        watch: {
            ['models.search'](newValue, oldValue) {
                this.searchPlace()
              
            },
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>